import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearCart } from '../services/cartService';
import API_BASE_URL from '../config';

export default function OrderResult() {
    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const status = query.get('status');
    const method = query.get('method');
    const orderId = query.get('orderId');

    const isSuccess = status === 'success';
    const isBank = method === 'bank';
    const isCash = method === 'cash';
    const isIute = method === 'iute';
    // default to card if method is missing for backwards compatibility

    React.useEffect(() => {
        if (isSuccess) {
            clearCart();
        }
    }, [isSuccess]);

    const pdfUrl = `${API_BASE_URL.replace('/api', '')}/uploads/pdf/GlobeShops.pdf`;

    const containerStyle = {
        maxWidth: isBank ? '900px' : '600px',
        margin: '40px auto',
        padding: '30px 20px',
        textAlign: 'center',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
    };

    const iconStyle = {
        fontSize: '48px',
        marginBottom: '15px',
        display: 'block'
    };

    const titleStyle = {
        fontSize: '24px',
        fontWeight: '700',
        color: isSuccess ? '#2e7d32' : '#d32f2f',
        marginBottom: '10px'
    };

    const textStyle = {
        fontSize: '16px',
        color: '#666',
        marginBottom: isBank ? '20px' : '30px',
        lineHeight: '1.6'
    };

    const buttonStyle = {
        padding: '12px 30px',
        background: '#047ba8',
        color: '#fff',
        border: 'none',
        borderRadius: '24px',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'background 0.2s',
        marginTop: isBank ? '20px' : '0'
    };

    const downloadButtonStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '16px 32px',
        background: '#f8fafc',
        color: '#047ba8',
        border: '2px solid #047ba8',
        borderRadius: '30px',
        fontSize: '16px',
        fontWeight: '700',
        textDecoration: 'none',
        transition: 'all 0.2s',
        marginBottom: '20px',
        marginTop: '10px',
        cursor: 'pointer'
    };

    // Determine titles and messages based on status and method
    const getTitle = () => {
        if (!isSuccess) return 'Pagesa dështoi ose u anulua';
        if (isBank) return 'Porosia u regjistrua me sukses!';
        if (isCash) return 'Porosia u krye me sukses!';
        if (isIute) return 'Porosia me Iute u regjistrua me sukses!';
        // isCard
        return 'Pagesa u krye me sukses!';
    };

    const getMessage = () => {
        if (!isSuccess) {
            return 'Pati një problem me procesimin e pagesës suaj ose procesi u anulua. Ju lutem provoni përsëri ose kontaktoni suportin opara se të tentoni nga e para.';
        }
        if (isBank) {
            return 'Porosia juaj është regjistruar. Ju lutem shkarkoni dokumentin e mëposhtëm për të kryer pagesën me bankë.';
        }
        if (isCash) {
            return 'Do të kontaktoheni nga kujdesi i klientit për të finalizuar blerjen.';
        }
        if (isIute) {
            return 'Porosia juaj me Iute u regjistrua me sukses! Ju do të merrni një email me detajet e porosisë.';
        }
        // isCard
        return 'Faleminderit për blerjen tuaj. Pagesa juaj me kartë u procesua me sukses. Ju do të merrni një email konfirmimi së shpejti.';
    };

    return (
        <div style={containerStyle}>
            <span style={iconStyle}>{isSuccess ? '✅' : '❌'}</span>
            <h1 style={titleStyle}>{getTitle()}</h1>
            {orderId && (
                <div style={{
                    display: 'inline-block',
                    padding: '6px 16px',
                    backgroundColor: '#f1f5f9',
                    color: '#0f172a',
                    borderRadius: '20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    marginBottom: '16px'
                }}>
                    Numri i Porosisë: #{orderId}
                </div>
            )}
            <p style={textStyle}>{getMessage()}</p>

            {isBank && isSuccess && (
                <div style={{ margin: '30px 0' }}>
                    <a
                        href={pdfUrl}
                        download="GlobeShops_Fatura.pdf"
                        target="_blank"
                        rel="noreferrer"
                        style={downloadButtonStyle}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#047ba8';
                            e.target.style.color = '#fff';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = '#f8fafc';
                            e.target.style.color = '#047ba8';
                        }}
                    >
                        <span style={{ fontSize: '20px' }}>📄</span> Shkarko të dhënat e pagesës (PDF)
                    </a>
                </div>
            )}

            <div>
                <button
                    style={buttonStyle}
                    onClick={() => navigate('/')}
                    onMouseEnter={(e) => e.target.style.background = '#036286'}
                    onMouseLeave={(e) => e.target.style.background = '#047ba8'}
                >
                    Kthehu në Faqen Kryesore
                </button>
            </div>
        </div>
    );
}
